import React, { useMemo } from "react";
import { useNavigate, useLocation } from "react-router-dom";

import InitialDataListPage from "../components/InitialDataListPage";

const StepUnitMain = ({
  masterList = [],
  name,
  onPageInsert,
  onRowSelected,
  fromServiceStep = false,
}) => {
  const navigate = useNavigate();
  const location = useLocation();
  const columns = useMemo(
    () => [
      {
        key: "index",
        header: "#",
        width: "8%",
        align: "center",
        render: (_item, _index, { startIndex, itemIndex }) =>
          startIndex + itemIndex + 1,
      },
      {
        key: "Unit_Name",
        header: "ชื่อหน่วย",
        width: "64%",
        align: "start",
        render: (item) => item.Unit_Name || "-",
      },
      {
        key: "Unit_Status",
        header: "สถานะ",
        width: "16%",
        align: "center",
        render: (item) => (item.Unit_Status === "Y" ? "ใช้งาน" : "ไม่ใช้งาน"),
      },
      {
        key: "actions",
        header: "แก้ไข",
        width: "12%",
        align: "center",
        isAction: true,
        render: (item, _index, { triggerRowSelected }) => (
          <button
            onClick={(event) => {
              event.stopPropagation();
              triggerRowSelected(item);
            }}
            className="btn btn-sm"
            title="แก้ไข"
            style={{
              width: "32px",
              height: "32px",
              borderRadius: "8px",
              border: "none",
              backgroundColor: "#fff3e0",
              color: "#EF6C00",
              transition: "all 0.2s ease",
            }}
            onMouseOver={(event) => {
              event.currentTarget.style.backgroundColor = "#EF6C00";
              event.currentTarget.style.color = "#fff";
            }}
            onMouseOut={(event) => {
              event.currentTarget.style.backgroundColor = "#fff3e0";
              event.currentTarget.style.color = "#EF6C00";
            }}
            type="button"
          >
            <i className="fas fa-edit" />
          </button>
        ),
      },
    ],
    []
  );

  const getSearchValues = useMemo(
    () => (item) => [
      item?.Unit_Name,
      item?.Unit_Status === "Y" ? "ใช้งาน" : "ไม่ใช้งาน",
    ],
    []
  );

  return (
    <InitialDataListPage
      name={name}
      entityPath="/stepunit"
      data={masterList}
      onCreate={onPageInsert}
      onRowSelected={onRowSelected}
      columns={columns}
      getSearchValues={getSearchValues}
      searchPlaceholder={`ค้นหา${name || "หน่วย"}...`}
      fieldMappings={{ no: "Unit_Id" }}
      getRowId={(item) => item?.Unit_Id}
      customHeader={
        fromServiceStep ? (
          <button
            onClick={() => {
              // ถ้ามี returnToForm ให้กลับไปที่ Form
              if (location.state?.returnToForm) {
                navigate("/servicestep", { 
                  state: { 
                    returnToForm: true,
                    formData: location.state.formData,
                    formDataList: location.state.formDataList,
                    mode: location.state.mode,
                    selectedService: location.state.selectedService
                  } 
                });
              } else {
                navigate("/servicestep");
              }
            }}
            className="btn d-flex align-items-center gap-2"
            style={{
              backgroundColor: "#6b7280",
              color: "#fff",
              borderRadius: "10px",
              padding: "10px 24px",
              fontWeight: "500",
              border: "none",
              boxShadow: "0 2px 8px rgba(107, 114, 128, 0.2)",
              transition: "all 0.3s ease",
            }}
            onMouseOver={(e) => {
              e.currentTarget.style.backgroundColor = "#4b5563";
              e.currentTarget.style.transform = "translateY(-1px)";
            }}
            onMouseOut={(e) => {
              e.currentTarget.style.backgroundColor = "#6b7280";
              e.currentTarget.style.transform = "translateY(0)";
            }}
            type="button"
          >
            <i className="fa fa-arrow-left"></i>
            <span>กลับหน้าขั้นตอนบริการ</span>
          </button>
        ) : null
      }
    />
  );
};

export default StepUnitMain;

